// extracted by mini-css-extract-plugin
module.exports = {"winnerImage":"__5_winnerImage__qAfGU","registerText":"__5_registerText__5Ttsr","signInText":"__5_signInText__BrLG2","sideBar":"__5_sideBar__nWWa6"};